import request from '@/utils/request'
import baseUrl from '@/utils/envConfig'
import qs from 'qs'

// 图片删除
export const deletePicture = (data: any) =>
  request({
    url: '/upload/picDelete',
    method: 'post',
    data: qs.stringify(data)
  })
// 文件删除
export const deleteFile = (data: any) =>
  request({
    url: '/upload/fileDelete',
    method: 'post',
    data: qs.stringify(data)
  })

// 获取上传token
export const getUploadToken = (data: any) =>
  request({
    url: '/upload/fileDelete',
    method: 'post',
    data: qs.stringify(data)
  })

// 图片接口地址
export const uploadImgUrl = baseUrl + '/upload/pic'

// 文件接口地址
export const uploadFileUrl = baseUrl + '/upload/file'

// P12上传地址
export const uploadSignFileUrl = baseUrl + '/upload/signFile'

// 视频上传地址
export const uploadVideoUrl = baseUrl + '/upload/uploadVideoFile'
